const toTopButton = document.querySelector("#back-to-top");

function toggleTopButton() {
  const scrollThreshold = 100;
  if (window.scrollY > scrollThreshold) {
    toTopButton.classList.add("is-visible");
  } else {
    toTopButton.classList.remove("is-visible");
  }
}

function backToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

if (toTopButton) {
  toggleTopButton();
  window.addEventListener("scroll", toggleTopButton);
  toTopButton.addEventListener("click", backToTop);
  window.addEventListener("pageshow", () => {
    requestAnimationFrame(() => {
      toggleTopButton();
    });
  });
}
